import { normalizeChainIdFromZeroXApi } from '@/lib/api/0x-cross-chain/constants';

import { CHAIN_ID_PER_NETWORK_URL_PATH } from '@/constants/chain';

/**
 * Parse a history chain identifier that may arrive as numeric string
 * (e.g. "8453") or network slug (e.g. "solana"). The 0x Solana chain ID resolves
 * to our internal one in both forms.
 */
export function parseHistoryChainId(
  rawChainId: string | number | null | undefined,
): number | undefined {
  if (!rawChainId) return undefined;

  if (typeof rawChainId === 'number') {
    return Number.isSafeInteger(rawChainId) && rawChainId > 0
      ? normalizeChainIdFromZeroXApi(rawChainId)
      : undefined;
  }

  const normalized = rawChainId.trim().toLowerCase();
  if (!normalized) return undefined;
  const chainIdFromSlug = CHAIN_ID_PER_NETWORK_URL_PATH[normalized];
  if (typeof chainIdFromSlug === 'number') return chainIdFromSlug;

  if (!/^\d+$/.test(normalized)) return undefined;

  const chainIdFromNumber = Number(normalized);
  if (Number.isSafeInteger(chainIdFromNumber) && chainIdFromNumber > 0)
    return normalizeChainIdFromZeroXApi(chainIdFromNumber);

  return undefined;
}
